<template>
  <div>
    <p>Tiempo restante: {{ formattedTime }}</p>
  </div>
</template>

<script>
import EventBus from '../event-bus';

export default {
  props: ['verification_code_sent_at'],
  data() {
    return {
      timeRemaining: null,
      timer: null
    };
  },
  computed: {
    formattedTime() {
      const hours = String(Math.floor(this.timeRemaining / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((this.timeRemaining % 3600) / 60)).padStart(2, '0');
      const seconds = String(this.timeRemaining % 60).padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    }
  },
  watch: {
    verification_code_sent_at(newVal) {
      this.startTimer();
    }
  },
  methods: {
    updateTimeRemaining() {
      const now = new Date().getTime();
      const targetTime = new Date(this.verification_code_sent_at).getTime();
      this.timeRemaining = Math.floor((targetTime - now) / 1000);

      if (this.timeRemaining <= 0) {
        clearInterval(this.timer);
        this.timeRemaining = 0;
      }
    },
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer); // Limpia el temporizador anterior si existe
      }
      this.updateTimeRemaining();
      this.timer = setInterval(this.updateTimeRemaining, 1000);
    }
  },
  created() {
    EventBus.on('show-timer', () => this.startTimer());
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
